import { createElementBlock as t, openBlock as a, normalizeClass as o, renderSlot as n, createElementVNode as s } from "vue";
import { _ as c } from "./main-DWIJXwA4.js";
const d = {
  name: "HeadingNode",
  props: {
    modelValue: {
      type: Object,
      required: !0
    }
  },
  computed: {
    node() {
      return this.modelValue;
    },
    customClasses() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.customClasses) || [];
    },
    anchorTag() {
      var e;
      return ((e = this.node.properties) == null ? void 0 : e.anchorTag) || "";
    }
  }
};
function l(e, u, i, m, p, r) {
  return a(), t("div", {
    class: o(["pb-heading", r.customClasses]),
    "data-anchor-tag": r.anchorTag
  }, [
    n(e.$slots, "default", {}, () => [
      s("div", {
        innerHTML: r.node.content.html
      }, null, 8, ["innerHTML"])
    ], !0)
  ], 10, ["data-anchor-tag"]);
}
const f = /* @__PURE__ */ c(d, [["render", l], ["__scopeId", "data-v-a9eb79ce"]]);
export {
  f as default
};
